import { Navigate, Route, Routes } from 'react-router-dom';

import * as routing from '../../../../constants/Routing';
import { BackofficeClientsProjectsDetails } from './details';
import { BackofficeClientsProjectsList } from './list';

export const BackofficeClientsProjects = () => {
  return (
    <Routes>
      <Route path="/" element={<BackofficeClientsProjectsList />} />
      <Route path="/details/:projectId" element={<BackofficeClientsProjectsDetails />} />
      <Route path="*" element={<Navigate to={routing.BACKOFFICE.CLIENTS.PROJECTS} />} />
    </Routes>
  );
};
